import type { GetServerSideProps, NextPage } from 'next';

import MetaTags from '../../components/layout/MetaTags';
import ProductDescription from '../../components/product/ProductDescription';
import ProductTop from '../../components/product/ProductTop';
import SimilarProducts from '../../components/product/SimilarProducts';
import productsService from '../../services/productsService';
import styles from '../../styles/ArticlePage.module.scss';
import type ProductDetailsType from '../../types/ProductDetailsType';
import type ProductType from '../../types/ProductType';

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const slug = String(query.slug);
  const { product } = await productsService.getProduct(slug);
  const similarProductsResponse = await productsService.getSimilarProducts(
    product.slug
  );

  return {
    props: {
      product,
      similarProducts: similarProductsResponse.products,
    },
  };
};

interface Props {
  product: ProductDetailsType;
  similarProducts: Array<ProductType>;
}

const ProductPage: NextPage<Props> = ({ product, similarProducts }) => {
  return (
    <div className={styles.productPage}>
      <MetaTags title={product.name} />
      <ProductTop product={product} />
      <ProductDescription product={product} />
      <SimilarProducts products={similarProducts} />
    </div>
  );
};

export default ProductPage;
